<template>
  <div>
    <SEMCover />

    <SEMDiagram />
    <!-- <SEMButton /> -->
    <SEMChart />
    <b-row>
      <b-col lg="6">
        <SEMMap />
      </b-col>
      <b-col lg="6">
        <SEMButton />
      </b-col>
    </b-row>
    <br>
    <SEMLog />
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import SEMDiagram from '@/views/lighting/ibiot-cab-3p/SEMDiagram.vue'
import SEMCover from '@/views/lighting/ibiot-cab-3p/SEMCover.vue'
import SEMMap from '@/views/lighting/ibiot-cab-3p/SEMMapDetail.vue'
import SEMButton from '@/views/lighting/ibiot-cab-3p/SEMButton.vue'
import SEMChart from '@/views/lighting/ibiot-cab-3p/SEMChart.vue'
import SEMLog from '@/views/lighting/ibiot-cab-3p/SEMLog.vue'
// import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    SEMCover,
    SEMMap,
    SEMButton,
    SEMDiagram,
    SEMChart,
    SEMLog,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style>
</style>
